import React from "react";
import IconComponent from "../Icons/IconComponent";

const Avatar = ({ onClick, href, heightAvatar, widthAvatar }) => {
    return (
        <button
            disabled={!onClick}
            className={"user-avatar" }
            type='button'
            style={{ cursor: onClick ? "pointer" : "default", height: heightAvatar ? heightAvatar : null, width: widthAvatar ? widthAvatar : null }}
            onClick={onClick}>
            {!href ?
                <IconComponent nameIcon={"user"}/> :
                <div
                    style={{
                        height: "36px", minHeight: heightAvatar ? heightAvatar : "36px", width: widthAvatar ? widthAvatar : "36px", minWidth: "36px",
                        borderRadius: "72px",
                        background: "url(" + href + ") var(--input-background) 50% / cover no-repeat"
                    }}/>}
        </button>
    );
};

export default Avatar;
